export interface IScrollMetrics {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}

/**
 * True when the scroll position is within `threshold` px of the bottom — i.e. the
 * user is "pinned" and live content should keep following. A small threshold
 * (not strict equality) tolerates sub-pixel rounding and bottom padding, so a
 * user who hasn't deliberately scrolled up still counts as pinned. Content
 * shorter than the viewport is always pinned.
 */
export default function isPinnedToBottom(
  { scrollTop, scrollHeight, clientHeight }: IScrollMetrics,
  threshold = 64
): boolean {
  return scrollHeight - (scrollTop + clientHeight) <= threshold;
}
